import React from 'react'
import { useNavigate } from 'react-router-dom';
import style from './PageNotFound.module.css'

const PageNotFound = () => {

    const navigate = useNavigate();
    

    return (
        <div className={style.container}>
            <h1 className={style.title}>404 Page Not Found</h1>
            <p onClick={() => navigate(-1)}>Go Back</p>
        </div>
    )
}

export default PageNotFound